module.exports = __webpack_public_path__ + "static/picture1-3c8559ba7753b184822362530e8e2ea3.png";